var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/throttle-debounce@1.1.0/~/throttle-debounce/index.js
// module id = Snhc
// module chunks = 5